import actions from 'actions/dashboardTemplates'
import { createChildFormViewContainer } from 'factories/ChildFormView'
import Component from 'components/DashboardTemplates/FormView/Section/FormView'

export default createChildFormViewContainer({ actions })(Component)
